import { SolicitarHomologacao } from "./SolicitarHomologacao";

export default SolicitarHomologacao